import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class BuyerFeedbackPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="container">
        <div className="well">
          <code>
            TODO: Buyer Feedback Leaderboard
          </code>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

BuyerFeedbackPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

BuyerFeedbackPage.defaultProps = {
};

BuyerFeedbackPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(BuyerFeedbackPage);
